import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { useUsers } from "@/components/pages/users/hooks/useUsers";
import { Role } from "@/types/user";
import { useChannelStateContext } from "stream-chat-react";
import { useUpdateChannelMetadata } from "@/components/pages/chats/component/hooks/useUpdateChannelMetadata";
import { useTranslation } from "react-i18next";

export const FrontDeskUserSelect = () => {
  const { t } = useTranslation();
  const { channel } = useChannelStateContext();
  const { updateMetadata } = useUpdateChannelMetadata();
  const { userProfile } = useAuthenticatedUser();

  const selectedUserId = channel?.data?.assigned_to_id;
  const isFrontDeskSession = userProfile?.role === Role.FRONT_DESK;
  const currentHotelId = userProfile?.profile?.hotelId;

  const { data: users, isLoading } = useUsers({
    roles: [Role.FRONT_DESK],
    ...(isFrontDeskSession && currentHotelId
      ? { hotelId: currentHotelId }
      : {}),
  });

  const handleUserChange = async (userId: string) => {
    await updateMetadata({
      assigned_to_id: userId,
    });
  };

  return (
    <Select value={selectedUserId} onValueChange={handleUserChange}>
      <SelectTrigger className="!max-h-full w-[10rem] bg-white border-slate-200 text-black shadow-sm focus:ring-1 focus:ring-slate-400">
        <SelectValue
          placeholder={isLoading ? t("chats.loading") : t("chats.assignTo")}
        />
      </SelectTrigger>
      <SelectContent>
        {users?.map((user) => (
          <SelectItem key={user.id} value={user.id}>
            {user.firstName} {user.lastName}
          </SelectItem>
        ))}
        {users?.length === 0 && !isLoading && (
          <div className="p-2 text-xs text-slate-500 text-center">
            {t("chats.noUsersFound")}
          </div>
        )}
      </SelectContent>
    </Select>
  );
};
